import {
    Button, Divider, Grid,ListItemText, styled,Chip, Avatar
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ContentEditable from "react-contenteditable";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import AnexosComponent, { EAnexoModulos } from "../../../../components/Anexos";
import {
    BootstrapDialog,
    BootstrapDialogTitle
} from "../../../../components/BootstrapDialogTitle";
import useStyles from "../../../../components/layout/Styles";
import SolidButton from "../../../../components/SolidButton";
import { useAlert } from "../../../../contexts/AlertContext";
import { usePallet } from "../../../../contexts/PalletContext";
import { EComentarioModulos, IAcaoPreparatoria, IComentario } from "../../../../models/Proposicao.Model";
import { ILoggedUser } from "../../../../models/User.Model";
import ComentarioService from "../../../../services/ComentarioService";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ButtonNoCount from "../../../../components/ButtonNoCount";
import ButtonChip from "../../../../components/ButtonChip";
import { IParlamentar } from "../../../../models/Parlamentar.Model";
import ButtonDialogConfirmation from "../../../../components/ButtonDialogConfirmation";
import { IProposicao } from "../../../../models/Proposicao.Model";


export default function RelatorioProposicaoModal(props: {
    proposicao: IProposicao,
    onChange?: () => (
        id: number,
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    closeMenu?: () => void;
    reloadLista?: () => void;
    children?: React.ReactNode;
    comentario?: IComentario;
    acao?: IAcaoPreparatoria;
    listaUsuario?: ILoggedUser[];
    resposta?: boolean;
}) {
    const { pallet } = usePallet();
    const classes = useStyles();
    const { NewAlert } = useAlert();

    const [idReferencia, setIdReferencia] = React.useState<number>();
    const [comentario, setComentario] = React.useState<string>();
    const [userList, setUserList] = useState<Array<number>>([]);
    const [lockSaveButton, setLockSaveButton] = useState<boolean>(true);
    const [lockedUserList, setLockedUserList] = useState<Array<number>>([]);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [newUserList, setNewUserList] = useState<Array<number>>([]);
    const navigate = useNavigate();
    const [idComentario, setIdComenatario] = useState(0);
    const [statusTramitacao,setStatusTramitacao] = useState<string>('nao');
    const [statusAcontecimento,setStatusAcontecimento] = useState<string>('nao');
    const [statusTimeline,setStatusTimeline] = useState<string>('nao');
    const [statusAcaoInfluencia,setStatusAcaoInfluencia] = useState<string>('nao');
    const [statusAcaoPreparatoria,setStatusAcaoPreparatoria] = useState<string>('nao');
    const [statusApensada,setStatusApensada] = useState<string>('nao');
    const [statusEmenda,setStatusEmenda] = useState<string>('nao');

    
    const FilterTag = styled(Chip)`
    padding: 10px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;       
    color: #160342;
    background-color: #DED3FF;
    border-radius: 39px;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
    margin-right: 2px;
`;

    const [comentarioNovo, setComentarioNovo] = useState("");
    const handleClickOpenModal = () => {
        setOpenModal(true);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    // useEffect(() => {
        
    //     setIdComenatario(Number(props.comentario.id));
    // }, []);

    useEffect(() => {
        SaveValidation();
    }, [comentarioNovo]);



    function SaveValidation() {
        if (comentarioNovo === "") {
            setLockSaveButton(false);
        } else setLockSaveButton(true);
    }

    const changeStatusTramitacao = () => { 
        if (statusTramitacao === 'sim') {
            setStatusTramitacao('nao')
        }else{
            setStatusTramitacao('sim')
        }
    }
    const changeStatusAcontecimento = () => { 
        if (statusAcontecimento === 'sim') {
            setStatusAcontecimento('nao')
        }else{
            setStatusAcontecimento('sim')
        }
    }

    const changeStatusTimeline = () => { 
        if (statusTimeline === 'sim') {
            setStatusTimeline('nao')
        }else{
            setStatusTimeline('sim')
        }
    }
    const changeStatusAcaoPreparatoria = () => { 
        if (statusAcaoPreparatoria === 'sim') {
            setStatusAcaoPreparatoria('nao')
        }else{
            setStatusAcaoPreparatoria('sim')
        }
    }
    const changeStatusAcaoInfluencia = () => { 
        if (statusAcaoInfluencia === 'sim') {
            setStatusAcaoInfluencia('nao')
        }else{
            setStatusAcaoInfluencia('sim')
        }
    }

    const changeStatusApensada = () => { 
        if (statusApensada === 'sim') {
            setStatusApensada('nao')
        }else{
            setStatusApensada('sim')
        }
    }
    const changeStatusEmenda = () => { 
        if (statusEmenda === 'sim') {
            setStatusEmenda('nao')
        }else{
            setStatusEmenda('sim')
        }
    }







    const [autocomplete, setAutocomplete] = React.useState(false);
    const [selecionado, setSelecionado] = React.useState(0);
    const indexSelecionado = useRef(selecionado);

    useEffect(() => {
        indexSelecionado.current = selecionado;
    }, [selecionado]);









    return (
        <Grid>
            <Button
                onClick={handleClickOpenModal}
                style={{
                    // fontWeight: pallet.fontWeight.subtitle,
                    fontSize: `${pallet.general.size14}`,
                    color: `${pallet.general.color4}`,
                }}
            >
                        <PictureAsPdfIcon style={{
          color: `${pallet.color.tertiary.font}`,
          marginRight: "10px",
          fontFamily: `${pallet.fontFamily.general}`,
        }} />
        <ListItemText></ListItemText>
        GERAR .PDF
                
            </Button>

            <BootstrapDialog
                style={{ paddingLeft: `${isMobile ? "0px" : "15px"}` }}
                sx={{ ".MuiPaper-root": { maxWidth: "600px" } }}
                maxWidth={"lg"}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openModal}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    GERAR .PDF
                </BootstrapDialogTitle>
                <Grid style={{marginBottom:"10px",
                              marginLeft:"7px",
                              fontFamily: "Montserrat", 
                              fontSize: "12px",
                              fontWeight:600,
                              paddingTop: "30px",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              display:'inline-block'
                              }}>
                  <Grid style={{display: "flex",
    alignItems: "center"}}><Grid style={{display:'inline-block'}}></Grid><Grid style={{display:'inline-block'}}>&nbsp;&nbsp;&nbsp;&nbsp;{props?.proposicao?.descricao}</Grid></Grid>
                </Grid>
                <Divider variant="fullWidth"/>
                <Grid style={{maxHeight:"400px",overflowY: "auto" }}>
                <Grid
                    container
                    style={{
                        
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >


                </Grid>
                <Grid
                    container
                    style={{
                        paddingTop: "30px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid style={{marginBottom:"10px",marginLeft:"7px",fontFamily: "Montserrat", fontSize: "12px",fontWeight:600}}>
                        TRAMITAÇÕES
                    </Grid>
                    <Grid item style={{ width: "600px"}}>
                    <ButtonChip
                      onClick={changeStatusTramitacao}
                      label={statusTramitacao === 'sim' ? "Sim" : "Não"}
                      active={statusTramitacao}
                    />

                  </Grid>
                </Grid>
                <Grid
                    container
                    style={{
                        paddingTop: "30px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid style={{marginBottom:"10px",marginLeft:"7px",fontFamily: "Montserrat", fontSize: "12px",fontWeight:600}}>
                        ACONTECIMENTOS
                    </Grid>
                    <Grid item style={{ width: "100%" }}>
                    <ButtonChip
                      onClick={changeStatusAcontecimento}
                      label={statusAcontecimento === 'sim' ? "Sim" : "Não"}
                      active={statusAcontecimento}
                    />

                  </Grid>
                </Grid>
                <Grid
                    container
                    style={{
                        paddingTop: "30px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid style={{marginBottom:"10px",marginLeft:"7px",fontFamily: "Montserrat", fontSize: "12px",fontWeight:600}}>
                        TIMELINE
                    </Grid>
                    <Grid item style={{ width: "100%" }}>
                    <ButtonChip
                      onClick={changeStatusTimeline}
                      label={statusTimeline === 'sim' ? "Sim" : "Não"}
                      active={statusTimeline}
                    />


                  </Grid>
                </Grid>
                <Grid
                    container
                    style={{
                        paddingTop: "30px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid style={{marginBottom:"10px",marginLeft:"7px",fontFamily: "Montserrat", fontSize: "12px",fontWeight:600}}>
                        AÇÃO PREPARATÓRIA
                    </Grid>
                    <Grid item style={{ width: "100%" }}>
                    <ButtonChip
                      onClick={changeStatusAcaoPreparatoria}
                      label={statusAcaoPreparatoria === 'sim' ? "Sim" : "Não"}
                      active={statusAcaoPreparatoria}
                    />

                  </Grid>
                </Grid>
                <Grid
                    container
                    style={{
                        paddingTop: "30px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid style={{marginBottom:"10px",marginLeft:"7px",fontFamily: "Montserrat", fontSize: "12px",fontWeight:600}}>
                        AÇÃO DE INFLUÊNCIA
                    </Grid>
                    <Grid item style={{ width: "100%" }}>
                    <ButtonChip
                      onClick={changeStatusAcaoInfluencia}
                      label={statusAcaoInfluencia === 'sim' ? "Sim" : "Não"}
                      active={statusAcaoInfluencia}
                    />

                  </Grid>
                </Grid>
                {/* <Grid
                    container
                    style={{
                        paddingTop: "30px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid style={{marginBottom:"10px",marginLeft:"7px",fontFamily: "Montserrat", fontSize: "12px",fontWeight:600}}>
                        APENSADAS
                    </Grid>
                    <Grid item style={{ width: "100%" }}>
                    <ButtonChip
                      onClick={changeStatusApensada  }
                      label={statusApensada === 'sim' ? "Sim" : "Não"}
                      active={statusApensada}
                    />

                  </Grid>
                </Grid> */}
                <Grid
                    container
                    style={{
                        paddingTop: "30px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid style={{marginBottom:"10px",marginLeft:"7px",fontFamily: "Montserrat", fontSize: "12px",fontWeight:600}}>
                        EMANDAS
                    </Grid>
                    <Grid item style={{ width: "100%" }}>
                    <ButtonChip
                      onClick={changeStatusEmenda  }
                      label={statusEmenda === 'sim' ? "Sim" : "Não"}
                      active={statusEmenda}
                    />
                  </Grid>
                </Grid>
                </Grid>



               

                <Grid>
                    <Divider variant="fullWidth" style={{ paddingTop: "30px" }} />
                </Grid>
                <Grid container style={{ justifyContent: "flex-end" }}>
                    <Grid
                        item
                        style={{
                            backgroundColor: `${pallet.backGroundPageColorPrimary}`,
                            paddingRight: `${isMobile ? "20px" : "40px"}`,
                            textAlignLast: "end",
                            padding: `${isMobile ? "10px 20px 10px 20px" : "20px 20px 20px 20px"}`,
                            display:"flex"
                        }}
                    >
                        <ButtonDialogConfirmation
                        styles={{
                            borderRadius: "6px 6px 6px 6px",
                            marginRight: "20px",
                            textTransform: "capitalize",
                            color: `${pallet.textColorPrimary}`,
                            backgroundColor: `${pallet.backgroundColorPrimary}` ,
                            fontWeight: pallet.general.weight_600,
                            fontFamily: `${pallet.general.fontFamily}`,
                            padding: `${isMobile ? "10px 20px 10px 20px" : "10px 20px 10px 20px"}`,
                            "&:hover": {
                                backgroundColor: `${pallet.backgroundColorPrimary}`,
                            },
                            
                        }}
                        title={"CONFIRMAÇÃO"}
                        title_button={"Cancelar"}
                        content={"Cancelar relatório ?"}
                        message={""}
                        confirmation_button={"Cancelar"}
                        confirmationEvent={() => {
                            handleClose()
                        }}
                    />
                  {/* onClick={() => window.open(`/interlocutor/relatorio/${props?.parlamentar.id}/${statusDemandaDados}/${statusDemandaLista}/${statusAcaoInfluenciaDados}/${statusAcaoInfluenciaLista}/${statusProposicaoDados}/${statusProposicaoLista}/${statusComissaoLista}/${statusDiscursoDados}/${statusDiscursoLista} `    , "_blank")} */}

                        <SolidButton 
                            onClick={() => window.open(`/proposicao/relatorio/${props?.proposicao.id}/${statusTramitacao}/${statusAcontecimento}/${statusTimeline}/${statusAcaoPreparatoria}/${statusAcaoInfluencia}/${statusApensada}/${statusEmenda}`, "_blank")}
                                                                                                       
                            color={`${pallet.textColorPrimary}`}
                            onChange={() => window.open(`/proposicao/relatorio/${props?.proposicao.id}/${statusTramitacao}/${statusAcontecimento}/${statusTimeline}/${statusAcaoPreparatoria}/${statusAcaoInfluencia}/${statusApensada}/${statusEmenda}`, "_blank")}
                                                                            

                            backgroundColor={`${pallet.backgroundColorPrimary}`}
                            fontSize={`${pallet.general.size14}`}
                            title={"GERAR PDF"}
                            disabled={false}
                        />
                    </Grid>
                </Grid>
            </BootstrapDialog>
        </Grid>
    );
}
